export default "__VITE_ASSET__C9T5MTLF__"